import type { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { hasValidAuthSession } from '../services/authGuard';
import { getLoginPathname } from '../services/authNavigation';

type Props = {
  children: ReactElement;
};

/**
 * Renders children only when access or refresh token exists and neither is expired.
 * Otherwise redirects to /login and stores return path in location state.
 */
export function ProtectedRoute({ children }: Props) {
  const location = useLocation();

  if (!hasValidAuthSession()) {
    const from = `${location.pathname}${location.search}`;
    return <Navigate to={getLoginPathname()} replace state={{ from }} />;
  }

  return children;
}
